<template>
    <div class="p-fluid">
        <div class="formgrid grid mt-2">
            <div class="field col-12 md:col-6 lg:col-3">
                <label>Ship To Code</label>
                <InputText v-model="forms.ship_to_code" required="true" autofocus
                    :class="{ 'p-invalid': errorAdd.ship_to_code }" />
                <small class="p-invalid" style="color: red" v-if="errorAdd.ship_to_code">{{ errorAdd.ship_to_code[0]
                    }}</small>
            </div>
            <div class="field col-12 md:col-6 lg:col-3">
                <label>Distributor Name</label>
                <InputText v-model="forms.distributor_name" required="true" autofocus
                    :class="{ 'p-invalid': errorAdd.distributor_name }" />
                <small class="p-invalid" style="color: red" v-if="errorAdd.distributor_name">{{
                    errorAdd.distributor_name[0] }}</small>
            </div>
            <div class="field col-12 md:col-6 lg:col-3">
                <label>Region</label>
                <Dropdown id="region_id" ref="dreg" dataKey="region_id" v-model="forms.region_id"
                    :loading="loadingDropdownRegion" :options="dataDropdownRegion" optionLabel="label"
                    optionValue="region_id" @change="changeUser()" placeholder="Pilih Region" :filter="true"
                    :showClear="true" @filter="searchDropdownRegion($event, 'filter')" />
                <small class="p-invalid" style="color: red" v-if="errorAdd.region_id">{{ errorAdd.region_id[0]
                    }}</small>
            </div>
            <div class="field col-12 md:col-6 lg:col-3">
                <label>City Name</label>
                <InputText v-model="forms.city_name" required="true" autofocus
                    :class="{ 'p-invalid': errorAdd.city_name }" />
                <small class="p-invalid" style="color: red" v-if="errorAdd.city_name">{{ errorAdd.city_name[0]
                    }}</small>
            </div>
            <div class="field col-12 md:col-6 lg:col-3">
                <label>Latitude</label>
                <InputText v-model="forms.latitude" required="true" autofocus
                    :class="{ 'p-invalid': errorAdd.latitude }" />
                <small class="p-invalid" style="color: red" v-if="errorAdd.latitude">{{ errorAdd.latitude[0] }}</small>
            </div>
            <div class="field col-12 md:col-6 lg:col-3">
                <label>Longitude</label>
                <InputText v-model="forms.longitude" required="true" autofocus
                    :class="{ 'p-invalid': errorAdd.longitude }" />
                <small class="p-invalid" style="color: red" v-if="errorAdd.longitude">{{ errorAdd.longitude[0]
                    }}</small>
            </div>

            <div class="field col-12 md:col-6 lg:col-3" v-if="type == 'edit'">
                <label>Status</label>
                <Dropdown ref="dstatus" v-model="forms.status_distributor" :options="dataDropdownStatus"
                    :class="{ 'p-invalid': errorAdd.status_distributor }" optionLabel="name" optionValue="code"
                    placeholder="Pilih Status" :showClear="true" />
                <small class="p-invalid" style="color: red" v-if="errorAdd.status_distributor">{{ errorAdd.status[0]
                }}</small>
            </div>

        </div>
        <div class="formgrid grid" v-if="type == 'create'">
            <div class="field col-12 md:col-6 lg:col-3">
                <label>User</label>
                <Listbox ref="duser" v-model="forms.mcu_id" :options="dataDropdownUser"
                    :class="{ 'p-invalid': errorAdd.mcu_id }" :multiple="true" :filter="true" optionLabel="label"
                    listStyle="max-height:250px" style="width:15rem" @filter="searchDropdownUser($event, 'add')">
                    <template #option="slotProps">
                        <div>{{ slotProps.option.label }}</div>
                    </template>
                </Listbox>
                <small class="p-invalid" style="color: red" v-if="errorAdd.mcu_id">{{
                    errorAdd.mcu_id[0]
                    }}</small>
            </div>
            <div class="field col-12 md:col-6 lg:col-9" v-if="convertMultiSelectUser(forms.mcu_id).length != 0">
                <div class="card" style="height: calc(60vh - 143px)">
                    <DataTable :value="forms.mcu_id" :scrollable="true" scrollHeight="flex">
                        <Column field="label" header="User">
                            <template #body="slotProps">
                                {{ slotProps.data.label }}
                            </template>
                        </Column>
                    </DataTable>
                </div>
            </div>
        </div>

        <div class="formgrid grid" v-if="type == 'edit'">
            <div class="col-12 flex justify-end gap-2">
                <Button label="Batal" icon="pi pi-times" class="p-button-secondary" :loading="loading" @click="handleCancel" />
                <Button label="Simpan" icon="pi pi-check" class="p-button-primary" :loading="loading" @click="update" />
            </div>
        </div>

    </div>


    <Button v-if="type == 'create'" :loading="loading" label="Simpan" icon="pi pi-save" class="p-button-primary"
        @click="saveNew" />
</template>

<script>

import { mapGetters } from "vuex";

export default {
    emits: ["submit"],
    props: {
        type: String,
        item: {}
    },
    data() {
        return {
            // loading
            loading: false,
            loadingDropdownRegion: false,
            loadingDropdownUser: false,

            // dataDropdown
            dataDropdownRegion: null,
            dataDropdownUser: null,
            dataDropdownStatus: [
                { name: 'Aktif', code: 'y' },
                { name: 'Nonaktif', code: 'n' },
            ],

            // addNew
            forms: {
                ship_to_code: null,
                distributor_name: null,
                region_id: null,
                city_name: null,
                latitude: null,
                longitude: null,
                status_distributor: 'y',
                mcu_id: [],
            },
        }
    },
    mounted() {
        this.$store.commit('setErrorAdd', {});
        if (this.type == "edit") {
            this.forms = this.item;
        }
    },
    created() {
        if (this.type == "edit") {
            this.searchDropdownRegion("", "edit", this.item.region_name);
        } else {
            this.searchDropdownRegion("");
        }
    },
    computed: {
        ...mapGetters(['errorAdd']),
        ...mapGetters("auth", ["user"]),
    },
    methods: {
        convertMultiSelectUser(data) {
            if (data) {
                return data.map((item) => {
                    return item.mcu_id;
                });
            } else {
                return [];
            }
        },
        // DROPDOWN
        searchDropdownRegion(event, purpose, valueEdit) {
            setTimeout(() => {
                if (valueEdit) {
                    this.$refs.dreg.filterValue = valueEdit;
                }

                if (purpose == "filter") {
                    this.loadingDropdownRegion = true;
                }

                this.axios({
                    method: "GET",
                    url: process.env.VUE_APP_ROOT_API + "web/select2/region-distributor",
                    params: {
                        search: valueEdit ? valueEdit : event.value
                    },
                })
                    .then((res) => {
                        if (purpose == "filter") {
                            this.dataDropdownRegion = res.data.data;
                            this.loadingDropdownRegion = false;
                        } else if (purpose == null) {
                            this.dataDropdownRegion = res.data.data;
                        } else if (purpose == "edit") {
                            this.dataDropdownRegion = res.data.data;
                            this.loadingDropdownRegion = false;
                        }
                    })
                    .catch((err) => {
                        console.log(err);
                    });
            }, 250);
        },
        changeUser() {
            if (this.type == 'create') {
                this.forms.mcu_id = [];
                this.dataDropdownUser = null;
                this.searchDropdownUser("");
            }

        },
        searchDropdownUser(event, purpose, valueEdit) {
            setTimeout(() => {

                if (valueEdit) {
                    this.$refs.duser.filterValue = valueEdit;
                }

                if (purpose == "add") {
                    this.loadingDropdownUser = true;
                }

                this.axios({
                    method: 'GET',
                    url: process.env.VUE_APP_ROOT_API + 'web/select2/user-distributor',
                    params: {
                        "search": valueEdit ? valueEdit : event.value,
                        "region_id": this.forms.region_id
                    }
                })
                    .then(res => {

                        if (purpose == "add") {
                            this.dataDropdownUser = res.data.data;
                            this.loadingDropdownUser = false;
                        } else if (purpose == null) {
                            this.dataDropdownUser = res.data.data;
                        }
                    })
                    .catch((err) => {
                        console.log(err);
                    });

            }, 250);
        },
        // ADDNEW
        saveNew() {
            this.loading = true;

            const data = {
                ...this.forms,
                mcu_id: this.convertMultiSelectUser(this.forms.mcu_id)
            };

            this.axios({
                method: 'POST',
                url: process.env.VUE_APP_ROOT_API + 'web/master-distributor/create',
                data: data,
            })
                .then((res) => {
                    this.loading = false;
                    if (res) {
                        this.$toast.add({ severity: 'success', summary: 'Successful', detail: 'Data Successfully Saved', life: 3000, });
                        this.$store.commit('setErrors', {});
                        this.$store.commit('setErrorAdd', {});
                        this.clearForms();

                        this.$emit('submit');
                    }
                })
                .catch((err) => {
                    console.log(err);
                    this.loading = false;
                    this.$store.commit('setErrorAdd', err.response.data.data);
                    this.$toast.add({ severity: 'error', summary: 'Failed', detail: 'Data Failed to Saved', life: 3000, });
                });
        },
        update() {
            this.loading = true;

            const data = {
                ...this.forms,
            };

            this.axios({
                method: 'POST',
                url: process.env.VUE_APP_ROOT_API + 'web/master-distributor/update',
                data: data,
            })
                .then((res) => {
                    this.loading = false;
                    if (res) {
                        this.$toast.add({ severity: 'success', summary: 'Successful', detail: 'Data Successfully Saved', life: 3000, });
                        this.$store.commit('setErrors', {});
                        this.$store.commit('setErrorAdd', {});
                        this.clearForms();

                        this.$emit('submit');
                        this.$emit('close');
                    }
                })
                .catch((err) => {
                    console.log(err);
                    this.loading = false;
                    this.$store.commit('setErrorAdd', err.response.data.data);
                    this.$toast.add({ severity: 'error', summary: 'Failed', detail: 'Data Failed to Saved', life: 3000, });
                });
        },
        clearForms() {
            this.forms.ship_to_code = null;
            this.forms.distributor_name = null;
            this.forms.region_id = null;
            this.forms.city_name = null;
            this.forms.longitude = null;
            this.forms.latitude = null;
            this.forms.mcu_id = [];
        },

        // edit
        handleCancel() {
            this.$emit('cancel')  // emit ke parent
        },
    }
}
</script>